import React from "react";

const TableCustomMain = React.lazy(() => import("./TableCustomMain"));

export default TableCustomMain;
